import React from 'react'
import style from './AddToCartButton.module.scss'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'

interface IAddToCartButtonProps {
  quantity: number
  findability: boolean
  index: number
  onAddToCart: (qnt: number, index: number) => void
}

const AddToCartButton = ({ quantity, findability, index, onAddToCart }: IAddToCartButtonProps) => {
  const { t } = useSurveyLocale()
  return (
    <div className={style.buttonContainer} data-testid="SW-EC-AddToCartButton">
      {0 === quantity || findability ? (
        <button className={style.single} disabled={findability && 1 === quantity} onClick={() => onAddToCart(1, index)}>
          {t('questions', 'ec', 'costco', 'addToCart')}
        </button>
      ) : (
        <div className={style.spin}>
          <button className={`${1 === quantity ? style.basket : style.minus}`} onClick={() => onAddToCart(-1, index)} />
          <div className={style.count}>{quantity}</div>
          <button className={style.plus} onClick={() => onAddToCart(1, index)} />
        </div>
      )}
    </div>
  )
}
export default AddToCartButton
